import React, { FC } from 'react'

import { ErrorMessage, useField } from 'formik'

import { KeyInput, KeyInputProps } from '@/key-components/KeyInput'

interface KeyInputFieldProps extends KeyInputProps {
  showError?: boolean
  placeholderColor?: string
  parentClass?: string
  afterChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

// Allows easier usage of input field inside Formik forms
/**
 * @deprecated key-* components are no longer supported.
 */
export const KeyInputField: FC<KeyInputFieldProps> = (props) => {
  const [field] = useField(props.name)

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    field.onChange(e)
    if (props.afterChange) props.afterChange(e)
  }

  return (
    <div className={props.parentClass}>
      <KeyInput
        {...field}
        {...props}
        onChange={handleChange}
      />
      {props.showError && (
        <ErrorMessage name={props.name}>
          {(msg) => <p className='text-error'>{msg}</p>}
        </ErrorMessage>
      )}
    </div>
  )
}
